import React from "react"
import QaiChallengeResponseDialog from "../Shared/QaiChallengeResponseDialog"
import GetChallengeNoteViewModel from "../Shared/ViewModels/GetChallengeNoteViewModel"

interface IQaQaiResponseContainerProps {
    view: string
    open: boolean
    challenge: GetChallengeNoteViewModel
    setChallenge: (value: GetChallengeNoteViewModel | null) => void
    getChallenges: () => void
}

export default function QaQaiResponseContainer({ view, open, challenge, setChallenge, getChallenges }: IQaQaiResponseContainerProps) {

    const close = () => {
        setChallenge(null);
    }

    const refresh = () => {
        getChallenges()
    }

    return (
        <QaiChallengeResponseDialog
            view={view}
            open={open}
            close={close}
            refresh={refresh}
            action='UpdateNoteResponse'
            id={challenge.id}
            name={challenge.name}
            note={challenge.note}
        />
    )
}